export class UpdateBackupZeroEtlPolicyInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "multiResourceConfiguration",
            "baseName": "multiResourceConfiguration",
            "type": "MultiResourceBackupZeroEtlConfiguration",
            "format": ""
        },
        {
            "name": "singleResourceConfiguration",
            "baseName": "singleResourceConfiguration",
            "type": "SingleResourceBackupZeroEtlConfiguration",
            "format": ""
        },
        {
            "name": "catalogConfiguration",
            "baseName": "catalogConfiguration",
            "type": "BackupZeroEtlCatalogConfiguration",
            "format": ""
        },
        {
            "name": "accessConfiguration",
            "baseName": "accessConfiguration",
            "type": "BackupZeroEtlAccessConfiguration",
            "format": ""
        },
        {
            "name": "tableFilters",
            "baseName": "tableFilters",
            "type": "BackupZeroEtlFilters",
            "format": ""
        },
        {
            "name": "syncFrequencyMinutes",
            "baseName": "syncFrequencyMinutes",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return UpdateBackupZeroEtlPolicyInput.attributeTypeMap;
    }
    constructor() {
    }
}
